const resizeCloudinaryImage = (url: string, width: string) => {
  if (typeof url !== 'string' || !url.includes('/upload/') || !width) {
    return url;
  }

  return url.replace('/upload/', `/upload/w_${width}/`);
};

export default resizeCloudinaryImage;
